import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import { InsuranceCoverageMonitor } from "../../../../../../services/api/insurance/monitor/types";
import { getRequirementDefinitionTableCellProps } from "../../../../../RequirementDefinitions/utils";
import {
  CellsConfig,
  ContextItem,
  RequirementTableCallback
} from "../../../../types";
import { getRequirementEngagementsTableCellProps } from "../../../../utils";
import { getPayoutMethodRequirementName } from "../helpers/getPayoutMethodRequirementName";
import { getPayoutMethodRequirementPayeeStatusCell } from "../helpers/getPayoutMethodRequirementPayeeStatusCell";

export const usePayeePayoutMethodConfig = (
  _callback: RequirementTableCallback
): CellsConfig<
  IRequirementResponse,
  ContextItem,
  InsuranceCoverageMonitor | undefined
> => {
  return {
    isActionRequired: () => false,

    requirementName: getPayoutMethodRequirementName,

    toolbarActions: (requirement, context, additionalData) => {
      return [];
    },

    nameCell: requirement => ({
      text: getPayoutMethodRequirementName(requirement)
    }),

    typeCell: requirement =>
      getRequirementDefinitionTableCellProps({
        type: requirement.requirementType
      }),

    statusCell: getPayoutMethodRequirementPayeeStatusCell,

    engagementsCell: getRequirementEngagementsTableCellProps
  };
};
